import { render, staticRenderFns } from "./EditBrand.vue?vue&type=template&id=25bccd48&scoped=true"
import script from "./EditBrand.vue?vue&type=script&lang=js"
export * from "./EditBrand.vue?vue&type=script&lang=js"
import style0 from "./EditBrand.vue?vue&type=style&index=0&id=25bccd48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bccd48",
  null
  
)

export default component.exports